import { Link } from "react-router-dom";

export default function PublicHome() {
  const year = new Date().getFullYear();

  return (
    <div className="landing">
      <header className="landing__nav">
        <div className="landing__brand">
          <img
            src="/teltrip-logo.png"
            alt="Teltrip"
            className="landing__logo"
            loading="lazy"
          />
          <Link to="/" className="landing__nav-link landing__nav-link--active">
            Home
          </Link>
        </div>
        <div className="landing__actions">
          <Link
            to="/contact-sales"
            className="landing__nav-button landing__nav-button--ghost"
          >
            Contact sales
          </Link>
          <Link to="/login" className="landing__nav-button landing__nav-button--primary">
            Sign in
          </Link>
        </div>
      </header>

      <main className="landing__hero">
        <div className="landing__copy">
          <p className="landing__eyebrow">Teltrip eSIM partners</p>
          <h1 className="landing__title">
            Build a global eSIM business with reseller-ready margins.
          </h1>
          <p className="landing__subtitle">
            Launch new destinations in minutes, control pricing in real time, and
            deliver instant activation for your travelers and enterprise clients.
          </p>
          <div className="landing__cta">
            <Link to="/login" className="landing__cta-primary">
              Sign in
            </Link>
            <Link to="/contact-sales" className="landing__cta-secondary">
              Contact sales
            </Link>
          </div>
          <div className="landing__stats">
            <div className="landing__stat">
              <span className="landing__stat-value">190+</span>
              <span className="landing__stat-label">Destinations</span>
            </div>
            <div className="landing__stat">
              <span className="landing__stat-value">4G/5G</span>
              <span className="landing__stat-label">Tier-1 networks</span>
            </div>
            <div className="landing__stat">
              <span className="landing__stat-value">24/7</span>
              <span className="landing__stat-label">Partner support</span>
            </div>
          </div>
        </div>

        <div className="landing__visual">
          <div className="landing__visual-card landing__visual-card--main">
            <div className="landing__visual-header">
              <span className="landing__pill">Live inventory</span>
              <span className="landing__pill landing__pill--outline">Instant activation</span>
            </div>
            <div className="landing__visual-grid">
              <div className="landing__mini-card">Europe</div>
              <div className="landing__mini-card">Asia</div>
              <div className="landing__mini-card">Americas</div>
              <div className="landing__mini-card">Africa</div>
              <div className="landing__mini-card">Global</div>
              <div className="landing__mini-card">B2B</div>
            </div>
            <div className="landing__visual-footer">
              <span className="landing__signal">99.9% uptime</span>
              <span className="landing__signal">Margin controls</span>
            </div>
          </div>

          <div className="landing__float landing__float--top">
            <span>Multi-network</span>
            <strong>Coverage</strong>
          </div>
          <div className="landing__float landing__float--bottom">
            <span>Automated</span>
            <strong>Provisioning</strong>
          </div>
          <div className="landing__glow" />
        </div>
      </main>

      <section className="landing__trust">
        <p className="landing__trust-title">
          Designed for travel brands, marketplaces, and telecom partners.
        </p>
        <div className="landing__trust-row">
          <span>Travel retail</span>
          <span>Marketplace partners</span>
          <span>Corporate travel</span>
          <span>Affiliate resellers</span>
        </div>
      </section>

      <footer className="landing__footer">
        <div className="landing__footer-brand">
          <img
            src="/teltrip-logo.png"
            alt="Teltrip"
            className="landing__footer-logo"
            loading="lazy"
          />
        </div>
        <div className="landing__footer-links">
          <a
            href="https://teltrip.com/policies/privacy-policy"
            target="_blank"
            rel="noreferrer"
          >
            Privacy policy
          </a>
          <a
            href="https://teltrip.com/policies/terms-of-service"
            target="_blank"
            rel="noreferrer"
          >
            Terms and conditions
          </a>
          <span>Copyright {year} Teltrip. All rights reserved.</span>
        </div>
      </footer>
    </div>
  );
}
